import React from 'react';
import GenericBadge from 'components/Utils/GenericBadge/index';
import SelectableListItem from 'components/Utils/SelectableListItem';

const NoItem = ({ show, itemText = 'items' }) =>
  show && (
    <SelectableListItem
      selected={false}
      disabled={true}
      divider={false}
      item={<GenericBadge title={`No ${itemText} to show`} />}
    />
  );

export default NoItem;
